import { motion, AnimatePresence } from 'framer-motion';
import { Wifi, WifiOff, Loader2 } from 'lucide-react';

type ConnectionState = 'connected' | 'reconnecting' | 'disconnected';

interface ConnectionStatusProps {
  state: ConnectionState;
}

export default function ConnectionStatus({ state }: ConnectionStatusProps) {
  if (state === 'connected') return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="fixed top-4 left-1/2 -translate-x-1/2 z-50 safe-area-top"
      >
        <div className={`
          flex items-center gap-2 px-4 py-2 rounded-full font-bold text-sm
          ${state === 'reconnecting' 
            ? 'bg-chaos-yellow/20 text-chaos-yellow border border-chaos-yellow/30' 
            : 'bg-destructive/20 text-destructive border border-destructive/30'
          }
        `}>
          {state === 'reconnecting' ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              <span>Reconnecting...</span>
            </>
          ) : (
            <>
              <WifiOff className="h-4 w-4" />
              <span>Connection lost</span>
            </>
          )}
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
